// extracted by mini-css-extract-plugin
module.exports = {"p-2":"CommonStyles_p-2__L2tk-","p-4":"CommonStyles_p-4__1t5BJ","mr4":"CommonStyles_mr4__1QyyX","mr2":"CommonStyles_mr2__2p5Mk","flex":"CommonStyles_flex__3lWMd"};